import type { ReactNode } from "react";

interface ChartCardProps {
  eyebrow?: string;
  title: string;
  description?: string;
  children: ReactNode;
}

export function ChartCard({ eyebrow, title, description, children }: ChartCardProps) {
  return (
    <section
      style={{
        borderRadius: "24px",
        padding: "24px",
        background: "linear-gradient(180deg, rgba(9, 14, 26, 0.92), rgba(7, 11, 21, 0.82))",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 18px 42px rgba(3, 8, 20, 0.24)"
      }}
      className="stack-md"
    >
      <div className="stack-xs">
        {eyebrow ? <span className="card-eyebrow">{eyebrow}</span> : null}
        <h3 className="card-title">{title}</h3>
        {description ? <p className="card-copy">{description}</p> : null}
      </div>
      <div className="chart-shell">{children}</div>
    </section>
  );
}
